/**
 * 英语（美式）
 */
var enUS = {
  locale: 'en-US',
  Common: {
    pleaseInput: 'Please input',
    pleaseSelect: 'Please select',
    confirm: 'Confirm',
    clear: 'Clear',
    cancel: 'Cancel',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    reset: 'Reset'
  },
  Exception: {
    emptyData: 'No data',
    error: 'Page error.try again later',
    networkError: 'network error'
  },
  List: {
    noMoreData: 'No more data',
    networkError: 'network error',
    clickRetry: 'try again'
  },
  DateRangePicker: {
    startTime: 'Start Time',
    endTime: 'End Time',
    timeRange: 'Time Range'
  }
};

export { enUS as default };
